import React, { useState } from "react";
import useFetchDlqRedriveInfo from "../../hooks/useFetchDlqRedriveInfo";
import { DLQItem } from "../../lusca-search-api/generated-src";
import { AsyncActionButton, asyncStatusMap } from "../common/AsyncActionButton";

interface DlqRedriveStatusIndicatorProps {
  stage: string;
  dlqItem: DLQItem;
}

const DlqRedriveStatusIndicator: React.FC<DlqRedriveStatusIndicatorProps> = ({
  stage,
  dlqItem,
}) => {
  const [shouldRedrive, requestRedrive] = useState(false);
  const { redrivenMessages } = useFetchDlqRedriveInfo(
    stage,
    dlqItem.pk,
    shouldRedrive
  );
  const { status, error } = (shouldRedrive
    ? redrivenMessages?.get(dlqItem.pk)
    : null) ?? { status: "unknown", error: undefined };

  return (
    <AsyncActionButton
      label="Requeue Message"
      successLabel="Requeue Successful"
      failedLabel="Requeue Failed"
      status={asyncStatusMap[status]}
      onClick={() => requestRedrive(true)}
      errorMessage={error}
    />
  );
};

export default DlqRedriveStatusIndicator;
